import React from 'react'
import Header from '../Components/Header'
import Feed from '../Components/Feed'
import Modal from '../Components/Modal'

function Sociagram() {
    return (
        <div>
            <div className="">


                
                <Header />
                <Feed />
        
                <Modal />

            </div>
        </div>
    )
}

export default Sociagram
